import { LoadPanel } from "devextreme-react";
import React, { ReactNode, useState } from "react";

type LoaderContext = {
  showLoader: () => void;
  hideLoader: () => void;
};

type LoaderContextProvider = {
  children: ReactNode;
};

export const LoadingContext = React.createContext<LoaderContext | undefined>(
  undefined
);

export const LoaderProvider: React.FC<LoaderContextProvider> = ({
  children,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const contextValue: LoaderContext = {
    showLoader: () => {
      setIsLoading(true);
    },
    hideLoader: () => {
      setIsLoading(false);
    },
  };

  return (
    <LoadingContext.Provider value={contextValue}>
      {isLoading && (
        <LoadPanel
          visible={true}
          showIndicator={true}
          showPane={true}
          shading={true}
          shadingColor="rgba(0, 0, 0, 0.3)"
        />
      )}
      {children}
    </LoadingContext.Provider>
  );
};
